<template>
  <div class="Choose">
    <el-select class="Choose-select"
               v-model="value"
               style="width: 100%"
               clearable filterable placeholder="Select a node" @change="chooseNode">
      <el-option v-for="item in allList"
                 :key="item.id"
                 :value="item.id"
                 :label="item.name"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'choose',
    props: {
      index: Number,
      addNode: Function,
    },

    data() {
      return {
        value: '',
      };
    },

    computed: {
      ...mapState('nodes', {
        allList: 'allList',
      }),
    },

    methods: {
      chooseNode() {
        this.addNode(this.index, this.value);
      },
    },
  };
</script>

<style lang="scss">
  .Choose {
    .el-input{
      width: 353px;
      height: 56px;
      border-radius: 0;
      border: 1px solid #F2F2F5;
      font-size: 17px;
      color: #323233;
    }
    .el-input__inner{
      width: 353px;
      height: 56px;
      border-radius: 0;
      background: #FAFAFC;
    }
    .el-select .el-input.is-focus .el-input__inner{
      border-color: #FF8837;
    }
    .el-select .el-input__inner:focus {
      border-color: #FF8837;
    }

    .el-icon-arrow-up:before{
      // width: 0;
      // height: 0;
      // border: 5px solid transparent;
      // position: absolute;
      // left: 10px;
      // border-bottom-color: #c0c4cc;
      // top: 20px;
      width: 8px;
      height: 6px;
      background: url('../../assets/ic_arrow_down.svg');
      content: '';
      display: inline-block;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .el-select .el-input .el-select__caret {
      transform: none;
    }
    .el-select .el-input .el-select__caret.is-reverse{
      transform: rotate(180deg);
    }

  }
  .el-select-dropdown__list:hover .el-select-dropdown__item.selected {
    background-color: #DDDDDD;
    color: #606266;
  }

  li.el-select-dropdown__item.selected,
  .el-select-dropdown__list:hover .el-select-dropdown__item.selected.hover {
    background-color: #FF8837;
    color: white;
  }

  .el-select-dropdown__item.selected.hover, li.el-select-dropdown__item:hover {
    background-color: #FF8837;
    color: white;
  }
</style>
